import { startOfDay } from 'date-fns';

export function getDateWithLastDay(year: number, month: number): Date {
  const dateWithLastDay = new Date(year, month, 0);
  return startOfDay(dateWithLastDay);
}
